import React, { useState } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import LocalizedStrings from 'react-localization';

function InsuranceParams(props) {
  const strings = new LocalizedStrings({
    ru: {
      params: 'Ваши параметры:',
      include: 'включительно',
      mark: 'Марка авто',
      model: 'Модель авто',
      year: 'Год выпуска',
      fuelType: 'Вид топлива',
      dt: 'ДT',
      hybrit: 'Гибрид',
      elec: 'Электро',
      engine: 'Объем двигателя',
      trans: 'Трансмиссия',
      region: 'Область',
      city: 'Город',
      mech: 'Механика',
      tip: 'Типтроник',
      distance: 'Пробег',
      number: 'Номер авто',
      carPrice: 'Стоимость авто',
      year2: 'год',
      year3: 'лет',
      price: 'тыс',
      age1: 'Возраст водителя',
      dreiversCount: 'Водители',
      exp1: 'Стаж водителя',
      taxi: 'Такси',
      yes: 'Да',
      no: 'Нет',
      credit: 'Авто в кредите у банка?',
      change: 'Изменить',
      show: 'показать все',
      hide: 'свернуть',
      more: 'Больше '
    },
    ua: {
      params: 'Ваші параметри:',
      include: 'включно',
      mark: 'Марка авто',
      model: 'Модель авто',
      year: 'Рік випуску',
      fuelType: 'Вид пального',
      dt: 'ДП',
      hybrit: 'Гібрид',
      elec: 'Електро',
      engine: "Об'єм двигуна",
      trans: 'Трансмісія',
      region: 'Область',
      city: 'Місто',
      mech: 'Механіка',
      tip: 'Тіптронік',
      distance: 'Пробіг',
      number: 'Номер авто',
      carPrice: 'Вартість авто',
      year2: 'рік',
      year3: 'років',
      price: 'тис',
      age1: 'Вік водія',
      dreiversCount: 'Водії',
      driver1: 'водій',
      driver2: 'водія',
      exp1: 'Стаж водія',
      taxi: 'Таксі',
      yes: 'Так',
      no: 'Ні',
      credit: 'Авто в кредиті у банку?',
      change: 'Змінити',
      show: 'Показати всі',
      hide: 'Згорнути всі',
      more: 'Більше '
    },
  });
  const [showMore, toggleShow] = useState(false);
  const values = queryString.parse(props.location.search);

  const url = `?step=2&car=${values.car}&model=${values.model}&year=${values.year}&fuel=${values.fuel}&transmission=${values.transmission}&region=${values.region}&city=${values.city}${values.engine ? `&engine=${values.engine}` : ''}&distance=${values.distance}${values.number ? `&number=${values.number}` : ''}&price=${values.price}&drivers=${values.drivers}&age=${values.age}&experience=${values.experience}&taxi=${values.taxi}&credit=${values.credit}`;

  strings.setLanguage(props.locale);

  const mark = JSON.parse(localStorage.getItem('autoMarks')).find((item) => Number(item.value) === Number(values.car));
  const model = JSON.parse(localStorage.getItem('autoModels')).find((item) => Number(item.value) === Number(values.model));
  const fuel = JSON.parse(localStorage.getItem('autoFuels')).find((item) => Number(item.value) === Number(values.fuel));
  const region = JSON.parse(localStorage.getItem('regions')).find((item) => Number(item.value) === Number(values.region));
  const city = JSON.parse(localStorage.getItem('cities')).find((item) => Number(item.value) === Number(values.city));
  const transmission = JSON.parse(localStorage.getItem('transmissions')).find((item) => Number(item.value) === Number(values.transmission));
  const engine = values.engine !== 'undefined' ? values.engine : null;
  const carNumber = values.number !== 'undefined' ? values.number : null;
  const price = Number(values.price).toLocaleString('ru');

  return (
    <section id="kasco_offer-parameters" className="container">
      <div className="row">
        <div className="left-block">
          <h3 className="tit">{strings.params}</h3>
          <Link to={props.locale === 'ua' ? `/uk/kasko${url}` : `/kasko${url}`} className="back-calculation">{strings.change}</Link>
        </div>
        <div className="right-block">
          <div className="parameters-panel">
            <div className="mob-close">
              <svg width={12} height={12} viewBox="0 0 12 12" fill="none">
                <path d="M2 2L9.99915 9.99915" stroke="#788392" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /><path d="M9.99927 2L2.00012 9.99915" stroke="#788392" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <div className="flex">
              <div className="tit-mob">{strings.params}</div>
              <div className="item-parameters">
                <div className="tit">{strings.mark}</div>
                <div className="value">{mark.name} </div>
              </div>
              <div className="item-parameters">
                <div className="tit">{strings.model}</div>
                <div className="value">{model.name} </div>
              </div>
              <div className="item-parameters">
                <div className="tit">{strings.year}</div>
                <div className="value">{values.year}</div>
              </div>
              {engine
                && (
                  <div className="item-parameters">
                    <div className="tit">{strings.engine}</div>
                    <div className="value">до {values.engine} л {strings.include}</div>
                  </div>
                )}
              <div className="item-parameters">
                <div className="tit">{strings.fuelType}</div>
                <div className="value">{fuel.name}</div>
              </div>
              <div className="item-parameters">
                <div className="tit">{strings.trans}</div>
                <div className="value">{transmission.name}</div>
              </div>
              <div className="item-parameters">
                <div className="tit">{strings.region}</div>
                <div className="value">{region.name}</div>
              </div>
              <div className="item-parameters">
                <div className="tit">{strings.city}</div>
                <div className="value">{city.name}</div>
              </div>
              {carNumber
                && (
                <div className="item-parameters">
                  <div className="tit">{strings.number}</div>
                  <div className="value">{values.number}</div>
                </div>
                )}
              <div className="item-parameters">
                <div className="tit">{strings.distance}</div>
                <div className="value">{values.distance} {strings.price}. км</div>
              </div>
              <div className="item-parameters">
                <div className="tit">{strings.carPrice}</div>
                <div className="value">{price} $</div>
              </div>
              <div className={showMore === true ? 'item-parameters parameters-show' : 'item-parameters parameters-hide'}>
                <div className="tit">{strings.dreiversCount}</div>
                <div className="value">{values.drivers !== '4' ? values.drivers : 'Неограниченно'}</div>
              </div>
              <div className={showMore === true ? 'item-parameters parameters-show' : 'item-parameters parameters-hide'}>
                <div className="tit">{strings.age1}</div>
                <div className="value">{values.age.includes('>') ? values.age.replace('>', `${strings.more}`) : values.age} {strings.year3}</div>
              </div>
              <div className={showMore === true ? 'item-parameters parameters-show' : 'item-parameters parameters-hide'}>
                <div className="tit">{strings.exp1}</div>
                <div className="value">{values.experience.includes('>') ? values.experience.replace('>', `${strings.more}`) : values.experience} {strings.year3}</div>
              </div>
              <div className={showMore === true ? 'item-parameters parameters-show' : 'item-parameters parameters-hide'}>
                <div className="tit">{strings.taxi}</div>
                <div className="value">{values.taxi === 'true' ? strings.yes : strings.no}</div>
              </div>
              <div className={showMore === true ? 'item-parameters parameters-show' : 'item-parameters parameters-hide'}>
                <div className="tit">{strings.credit}</div>
                <div className="value">{values.credit === 'true' ? strings.yes : strings.no}</div>
              </div>
            </div>
            <Link to={props.locale === 'ua' ? `/uk/kasko${url}` : `/kasko${url}`} className="back-calculation btn-mob">{strings.change}</Link>
            <button type="button" className={showMore === true ? 'btn btn-hide' : 'btn btn-show'} onClick={() => toggleShow(!showMore)}><p><span className="txt-show">{strings.show}</span><span className="txt-hide">{strings.hide}</span></p><svg width={10} height={7} viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 1L5 5.17391L1 1" stroke="#0A7E3E" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /><path d="M9 1L5 5.17391L1 1" stroke="#189851" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg></button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default withRouter(InsuranceParams);
